import dayjs from 'dayjs';

export interface ResidentContact {
  id: string;
  name: string;
  avatarUrl?: string;
  lastMessage?: string;
  lastMessageTime?: dayjs.Dayjs;
  unreadCount?: number;
}

export interface ChatMessage {
  id: string;
  senderId: 'currentUser' | string;
  recipientId: string;
  text: string;
  timestamp: dayjs.Dayjs;
  isRead?: boolean;
}

export const residentContacts: ResidentContact[] = [
  {
    id: 'res1',
    name: 'Elena Rodriguez',
    avatarUrl: 'https://randomuser.me/api/portraits/women/60.jpg',
    lastMessage: 'Okay, I will check that out. Thanks!',
    lastMessageTime: dayjs().subtract(15, 'minute'),
    unreadCount: 2,
  },
  {
    id: 'res2',
    name: 'Carlos Gomez',
    avatarUrl: 'https://randomuser.me/api/portraits/men/45.jpg',
    lastMessage: 'Can you resend the document?',
    lastMessageTime: dayjs().subtract(1, 'hour'),
  },
  {
    id: 'res3',
    name: 'Sofia Fernandez',
    avatarUrl: 'https://randomuser.me/api/portraits/women/33.jpg',
    lastMessage: 'Perfect, see you then.',
    lastMessageTime: dayjs().subtract(3, 'hour'),
    unreadCount: 0,
  },
  {
    id: 'res4',
    name: 'Luis Hernandez',
    lastMessage: 'Payment confirmed.',
    lastMessageTime: dayjs().subtract(1, 'day'),
  },
];

export const chatHistory: Record<string, ChatMessage[]> = {
  res1: [
    { id: 'msg1', senderId: 'res1', recipientId: 'currentUser', text: 'Hello, I have a question about my last payment.', timestamp: dayjs().subtract(1, 'hour'), isRead: true },
    { id: 'msg2', senderId: 'currentUser', recipientId: 'res1', text: 'Hi Elena, sure, what is your question?', timestamp: dayjs().subtract(55, 'minute'), isRead: true },
    { id: 'msg3', senderId: 'res1', recipientId: 'currentUser', text: 'I thought I paid for 2 months, but the app shows only 1.', timestamp: dayjs().subtract(30, 'minute'), isRead: true },
    { id: 'msg4', senderId: 'currentUser', recipientId: 'res1', text: 'Let me check that for you. One moment please.', timestamp: dayjs().subtract(25, 'minute'), isRead: true },
    { id: 'msg5', senderId: 'currentUser', recipientId: 'res1', text: 'Okay, I see the issue. It was a small system glitch, it should be updated now. Please refresh your app.', timestamp: dayjs().subtract(18, 'minute'), isRead: false },
    { id: 'msg6', senderId: 'res1', recipientId: 'currentUser', text: 'Okay, I will check that out. Thanks!', timestamp: dayjs().subtract(15, 'minute'), isRead: false },
  ],
  res2: [
    { id: 'msg7', senderId: 'res2', recipientId: 'currentUser', text: 'Good morning, I need a copy of the community guidelines document.', timestamp: dayjs().subtract(2, 'hour') },
    { id: 'msg8', senderId: 'currentUser', recipientId: 'res2', text: 'Hi Carlos, I have attached it to this message.', timestamp: dayjs().subtract(1, 'hour').add(5, 'minute') },
    { id: 'msg9', senderId: 'res2', recipientId: 'currentUser', text: 'Can you resend the document?', timestamp: dayjs().subtract(1, 'hour') },
  ],
  res3: [
    { id: 'msg10', senderId: 'res3', recipientId: 'currentUser', text: 'Hi, is the clubhouse available for booking on Saturday?', timestamp: dayjs().subtract(5, 'hour') },
  ]
};
